import './FunctionButton.css';
export default function FunctionButton({ type, onClick, label, classNames }) {
    return (
        <div className={`function-button-container`}>
            <button
                type={type}
                className={classNames}
                onClick={onClick}
            >
                {label}
            </button>
        </div>
    );
}